var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _rect7, _rect8, _rect9, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFarGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 414 52.8",
    style: {
      enableBackground: "new 0 0 414 52.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#303030;}\n\t.st1{fill:#D1D3D4;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 39.5,
    className: "st0",
    width: 97.1,
    height: 10.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 39.5,
    className: "st1",
    width: 97.1,
    height: 10.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 39.5,
    className: "st0",
    width: 25.5,
    height: 10.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 27.3,
    className: "st0",
    width: 25.5,
    height: 10.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 15,
    className: "st0",
    width: 25.5,
    height: 10.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 2.7,
    className: "st0",
    width: 25.5,
    height: 10.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "390.3,42.1 390.3,39.5 387.7,39.5 387.7,40.2 389.6,40.2 389.6,42.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.7,40.2h4.6v-0.7h-4.6V40.2z M306.1,40.2h4.6v-0.7h-4.6V40.2z M313.5,40.2h4.6v-0.7h-4.6V40.2z  M320.9,40.2h4.6v-0.7h-4.6V40.2z M328.4,40.2h4.6v-0.7h-4.6V40.2z M335.8,40.2h4.6v-0.7h-4.6V40.2z M343.2,40.2h4.6v-0.7h-4.6 V40.2z M350.6,40.2h4.6v-0.7h-4.6V40.2z M358,40.2h4.6v-0.7H358V40.2z M365.4,40.2h4.6v-0.7h-4.6V40.2z M372.8,40.2h4.6v-0.7h-4.6 V40.2z M380.3,40.2h4.6v-0.7h-4.6V40.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "295.9,39.5 293.3,39.5 293.3,42.1 294,42.1 294,40.2 295.9,40.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.3,
    y: 43.5,
    className: "st0",
    width: 0.7,
    height: 2.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "293.3,47.2 293.3,49.8 295.9,49.8 295.9,49.1 294,49.1 294,47.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.7,49.8h4.6v-0.7h-4.6V49.8z M306.1,49.8h4.6v-0.7h-4.6V49.8z M313.5,49.8h4.6v-0.7h-4.6V49.8z  M320.9,49.8h4.6v-0.7h-4.6V49.8z M328.4,49.8h4.6v-0.7h-4.6V49.8z M335.8,49.8h4.6v-0.7h-4.6V49.8z M343.2,49.8h4.6v-0.7h-4.6 V49.8z M350.6,49.8h4.6v-0.7h-4.6V49.8z M358,49.8h4.6v-0.7H358V49.8z M365.4,49.8h4.6v-0.7h-4.6V49.8z M372.8,49.8h4.6v-0.7h-4.6 V49.8z M380.3,49.8h4.6v-0.7h-4.6V49.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "387.7,49.8 390.3,49.8 390.3,47.2 389.6,47.2 389.6,49.1 387.7,49.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.6,
    y: 43.5,
    className: "st0",
    width: 0.7,
    height: 2.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M324.6,14.6l2-2.4c0.3-0.3,0.7-0.9,0.8-1.2s0.2-0.5,0.2-0.8c0-0.4-0.2-0.6-0.7-0.6c-0.3,0-0.5,0.1-0.7,0.4 c-0.1,0.2-0.1,0.3-0.2,0.5l-1.4-0.1c0.1-1.4,0.8-2.1,2.3-2.1c1.4,0,2.1,0.7,2.1,2c0,0.6-0.1,1-0.5,1.6c-0.3,0.4-0.3,0.4-1.1,1.4 l-0.9,1.1h2.5v1.2h-4.5V14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.6,8.4h3.7v1.2h-2.4l-0.1,1.3l0.1,0c0.3-0.1,0.4-0.1,0.6-0.1c0.7,0,1.3,0.2,1.6,0.6 c0.3,0.4,0.5,0.9,0.5,1.7c0,0.9-0.2,1.4-0.5,1.8c-0.4,0.4-1,0.6-1.8,0.6c-1.4,0-2.2-0.6-2.2-2l1.4-0.2c0.1,0.6,0.3,0.9,0.8,0.9 c0.5,0,0.8-0.3,0.8-1.1c0-0.9-0.2-1.2-0.8-1.2c-0.3,0-0.6,0.1-0.8,0.4l-1.1-0.2L330.6,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.4,10c0-0.7,0.1-1,0.4-1.3c0.3-0.3,0.7-0.4,1.4-0.4c0.7,0,1.1,0.2,1.4,0.5c0.2,0.3,0.3,0.6,0.3,1.2v0.7 c0,0.7-0.1,1-0.4,1.3c-0.3,0.3-0.7,0.4-1.4,0.4c-0.7,0-1.2-0.1-1.5-0.5c-0.2-0.3-0.3-0.6-0.3-1.2V10z M337.8,10.1 c0-0.7-0.2-0.9-0.5-0.9c-0.4,0-0.6,0.3-0.6,0.9v0.4c0,0.7,0.1,1,0.6,1c0.4,0,0.5-0.3,0.5-1V10.1z M340.4,8.4h1.3l-2.3,7.1h-1.3 L340.4,8.4z M340.9,13.3c0-0.7,0.1-1,0.4-1.3c0.3-0.3,0.7-0.4,1.4-0.4c0.7,0,1.1,0.2,1.4,0.5c0.2,0.3,0.3,0.6,0.3,1.2V14 c0,0.7-0.1,1-0.4,1.3c-0.3,0.3-0.7,0.4-1.4,0.4c-0.7,0-1.2-0.2-1.5-0.5c-0.2-0.3-0.3-0.6-0.3-1.2V13.3z M343.2,13.4 c0-0.7-0.1-0.9-0.5-0.9c-0.4,0-0.6,0.3-0.6,0.9v0.4c0,0.7,0.2,0.9,0.6,0.9c0.4,0,0.5-0.3,0.5-0.9V13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.6,8.4h1.5v5.9h3v1.2h-4.5V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.7,11.1c0-1.1,0.2-1.6,0.6-2.1c0.5-0.5,1.1-0.7,2.1-0.7c1.1,0,1.7,0.2,2.2,0.8c0.4,0.5,0.5,1,0.5,2v1.7 c0,1.1-0.2,1.6-0.6,2.1c-0.5,0.5-1.1,0.7-2.1,0.7c-1.1,0-1.7-0.2-2.2-0.8c-0.3-0.4-0.5-1-0.5-2V11.1z M356.6,11.3 c0-1.3-0.3-1.7-1.2-1.7c-0.9,0-1.2,0.4-1.2,1.7v1.4c0,1.3,0.3,1.7,1.2,1.7c0.9,0,1.2-0.4,1.2-1.7V11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.5,9.7h-1.9V8.4h5.3v1.2H362v5.9h-1.5V9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.9,13.6c0,0.6-0.2,1-0.5,1.4c-0.4,0.4-1.1,0.7-2.1,0.7c-1,0-1.7-0.3-2.1-0.9c-0.3-0.5-0.5-1-0.5-2v-1.6 c0-1.1,0.2-1.7,0.6-2.1c0.5-0.5,1.1-0.7,2-0.7c1.6,0,2.4,0.7,2.5,2.1l-1.4,0.1c-0.1-0.7-0.4-1-1-1c-0.8,0-1.1,0.4-1.1,1.8v1.3 c0,1.3,0.3,1.8,1.1,1.8c0.7,0,1-0.3,1.1-1L371.9,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.9,11.1c0-1.1,0.2-1.6,0.6-2.1c0.5-0.5,1.1-0.7,2.1-0.7c1.1,0,1.7,0.2,2.2,0.8c0.4,0.5,0.5,1,0.5,2v1.7 c0,1.1-0.2,1.6-0.6,2.1c-0.5,0.5-1.1,0.7-2.1,0.7c-1.1,0-1.7-0.2-2.2-0.8c-0.3-0.4-0.5-1-0.5-2V11.1z M376.7,11.3 c0-1.3-0.3-1.7-1.2-1.7c-0.9,0-1.2,0.4-1.2,1.7v1.4c0,1.3,0.3,1.7,1.2,1.7c0.9,0,1.2-0.4,1.2-1.7V11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.5,8.4h1.5l1.5,5.1l1.5-5.1h1.5l-2.4,7.1h-1.3L378.5,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.4,8.4h4.5v1.2h-3v1.7h2.5v1.2H387v1.7h3v1.2h-4.5V8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392.8,15.5h-1.5V8.4h2.7c1,0,1.5,0.1,1.8,0.5c0.4,0.4,0.5,0.8,0.5,1.6c0,1.2-0.4,1.8-1.3,2.1l1.5,3h-1.7 l-1.3-2.8h-0.8V15.5z M393.8,11.5c0.7,0,1-0.3,1-0.9c0-0.7-0.3-1-1-1h-1v1.9H393.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.7,14.2l-0.4,1.3h-1.7l2.6-7.1h1.5l2.6,7.1h-1.7l-0.4-1.3H398.7z M400,10.2l-0.9,2.8h1.8L400,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.3,11.5h2.6v1.2c0,1-0.1,1.6-0.5,2c-0.5,0.6-1.1,0.8-2.2,0.8c-1.1,0-1.7-0.3-2.2-0.9c-0.3-0.5-0.5-1-0.5-2 v-1.5c0-1.1,0.2-1.7,0.6-2.2c0.5-0.5,1.1-0.7,2.1-0.7c1.7,0,2.5,0.7,2.5,2.1l-1.4,0.1c-0.1-0.7-0.4-1-1.1-1c-0.9,0-1.1,0.4-1.1,1.8 v1.3c0,1.3,0.3,1.8,1.2,1.8c0.8,0,1.2-0.4,1.2-1.3v-0.4h-1.1V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.3,8.4h4.5v1.2h-3v1.7h2.5v1.2h-2.5v1.7h3v1.2h-4.5V8.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.9,8.5h3.7v1.2h-2.4l-0.1,1.3l0.1,0c0.3-0.1,0.4-0.1,0.6-0.1c0.7,0,1.3,0.2,1.6,0.6 c0.3,0.4,0.5,0.9,0.5,1.7c0,0.9-0.1,1.4-0.5,1.8c-0.4,0.4-1,0.6-1.8,0.6c-1.4,0-2.2-0.6-2.2-2l1.4-0.2c0.1,0.6,0.3,0.9,0.8,0.9 c0.5,0,0.8-0.3,0.8-1.1c0-0.9-0.2-1.2-0.8-1.2c-0.3,0-0.6,0.1-0.8,0.4l-1.1-0.2L140.9,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.8,11.2c0-1,0.1-1.6,0.5-2.1c0.4-0.5,0.9-0.7,1.8-0.7c0.9,0,1.5,0.2,1.9,0.8c0.3,0.4,0.4,1,0.4,2V13 c0,1.1-0.1,1.6-0.5,2.1c-0.4,0.5-0.9,0.7-1.8,0.7c-0.9,0-1.5-0.2-1.9-0.8c-0.3-0.4-0.4-1-0.4-2V11.2z M148.8,11.3 c0-1.3-0.2-1.7-0.8-1.7c-0.6,0-0.8,0.4-0.8,1.7v1.5c0,1.3,0.2,1.7,0.8,1.7c0.6,0,0.8-0.4,0.8-1.7V11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.1,10.1c0-0.7,0.1-1,0.4-1.3c0.3-0.3,0.7-0.4,1.4-0.4c0.7,0,1.1,0.2,1.4,0.5c0.2,0.3,0.3,0.6,0.3,1.2v0.7 c0,0.7-0.1,1-0.4,1.3c-0.3,0.3-0.7,0.4-1.4,0.4c-0.7,0-1.2-0.1-1.5-0.5c-0.2-0.3-0.3-0.6-0.3-1.2V10.1z M153.4,10.2 c0-0.7-0.2-0.9-0.5-0.9c-0.4,0-0.6,0.3-0.6,0.9v0.4c0,0.7,0.1,1,0.6,1c0.4,0,0.5-0.3,0.5-1V10.2z M156,8.5h1.3l-2.3,7.1h-1.3 L156,8.5z M156.5,13.4c0-0.7,0.1-1,0.4-1.3c0.3-0.3,0.7-0.4,1.4-0.4c0.7,0,1.1,0.2,1.4,0.5c0.2,0.3,0.3,0.6,0.3,1.2v0.7 c0,0.7-0.1,1-0.4,1.3c-0.3,0.3-0.7,0.4-1.4,0.4c-0.7,0-1.2-0.2-1.5-0.5c-0.2-0.3-0.3-0.6-0.3-1.2V13.4z M158.9,13.5 c0-0.7-0.1-0.9-0.5-0.9s-0.6,0.3-0.6,0.9v0.4c0,0.7,0.2,0.9,0.6,0.9s0.5-0.3,0.5-0.9V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.2,8.5h1.5v5.9h3v1.2h-4.5V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.3,11.2c0-1.1,0.2-1.6,0.6-2.1c0.5-0.5,1.1-0.7,2.1-0.7c1.1,0,1.7,0.2,2.2,0.8c0.3,0.5,0.5,1,0.5,2v1.7 c0,1.1-0.2,1.6-0.6,2.1c-0.5,0.5-1.1,0.7-2.1,0.7c-1.1,0-1.7-0.2-2.2-0.8c-0.3-0.4-0.5-1-0.5-2V11.2z M172.2,11.4 c0-1.3-0.3-1.7-1.2-1.7c-0.9,0-1.2,0.4-1.2,1.7v1.4c0,1.3,0.3,1.7,1.2,1.7c0.9,0,1.2-0.4,1.2-1.7V11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.1,9.8h-1.9V8.5h5.3v1.2h-1.9v5.9h-1.5V9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.5,13.7c0,0.6-0.2,1-0.5,1.4c-0.4,0.4-1.1,0.7-2.1,0.7c-1,0-1.7-0.3-2.1-0.9c-0.3-0.5-0.5-1-0.5-2v-1.6 c0-1.1,0.1-1.7,0.6-2.1c0.5-0.5,1.1-0.7,2-0.7c1.6,0,2.4,0.7,2.5,2.1l-1.4,0.1c-0.1-0.7-0.4-1-1-1c-0.8,0-1.1,0.4-1.1,1.8v1.3 c0,1.3,0.3,1.8,1.1,1.8c0.7,0,1-0.3,1.1-1L187.5,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.5,11.2c0-1.1,0.2-1.6,0.6-2.1c0.5-0.5,1.1-0.7,2.1-0.7c1.1,0,1.7,0.2,2.2,0.8c0.3,0.5,0.5,1,0.5,2v1.7 c0,1.1-0.2,1.6-0.6,2.1c-0.5,0.5-1.1,0.7-2.1,0.7c-1.1,0-1.7-0.2-2.2-0.8c-0.3-0.4-0.5-1-0.5-2V11.2z M192.4,11.4 c0-1.3-0.3-1.7-1.2-1.7c-0.9,0-1.2,0.4-1.2,1.7v1.4c0,1.3,0.3,1.7,1.2,1.7c0.9,0,1.2-0.4,1.2-1.7V11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.1,8.5h1.5l1.5,5.1l1.5-5.1h1.5l-2.4,7.1h-1.3L194.1,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.1,8.5h4.5v1.2h-3v1.7h2.5v1.2h-2.5v1.7h3v1.2h-4.5V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.5,15.7h-1.5V8.5h2.7c1,0,1.5,0.1,1.8,0.5c0.4,0.4,0.5,0.8,0.5,1.6c0,1.2-0.4,1.8-1.3,2.1l1.5,3h-1.7 l-1.3-2.8h-0.7V15.7z M209.5,11.6c0.7,0,1-0.3,1-0.9c0-0.7-0.3-1-1-1h-1v1.9H209.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,14.3l-0.4,1.3h-1.7l2.6-7.1h1.5l2.6,7.1h-1.7l-0.4-1.3H214.4z M215.7,10.3l-0.9,2.8h1.8L215.7,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222,11.7h2.6v1.2c0,1-0.1,1.6-0.5,2c-0.5,0.6-1.1,0.8-2.2,0.8c-1.1,0-1.7-0.3-2.2-0.9c-0.4-0.5-0.5-1-0.5-2 v-1.5c0-1.1,0.2-1.7,0.6-2.2c0.5-0.5,1.1-0.7,2.1-0.7c1.7,0,2.5,0.7,2.5,2.1l-1.4,0.1c-0.1-0.7-0.4-1-1.1-1c-0.9,0-1.1,0.4-1.1,1.8 v1.3c0,1.3,0.3,1.8,1.2,1.8c0.8,0,1.2-0.4,1.2-1.3v-0.4H222V11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226,8.5h4.5v1.2h-3v1.7h2.5v1.2h-2.5v1.7h3v1.2H226V8.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.8,9.9l-1.1,0.4L0.2,9.2l2.1-0.9h1v7.1H1.8V9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.5,11c0-1,0.1-1.6,0.5-2.1c0.4-0.5,0.9-0.7,1.8-0.7c0.9,0,1.5,0.2,1.9,0.8c0.3,0.4,0.4,1,0.4,2v1.8 c0,1.1-0.1,1.6-0.5,2.1c-0.4,0.5-0.9,0.7-1.8,0.7c-0.9,0-1.5-0.2-1.9-0.8c-0.3-0.4-0.4-1-0.4-2V11z M8.6,11.1 c0-1.3-0.2-1.7-0.8-1.7C7.2,9.4,7,9.8,7,11.1v1.5c0,1.3,0.2,1.7,0.8,1.7c0.6,0,0.8-0.4,0.8-1.7V11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,11c0-1,0.1-1.6,0.5-2.1c0.4-0.5,0.9-0.7,1.8-0.7c0.9,0,1.5,0.2,1.9,0.8c0.3,0.4,0.4,1,0.4,2v1.8 c0,1.1-0.1,1.6-0.5,2.1c-0.4,0.5-0.9,0.7-1.8,0.7c-0.9,0-1.5-0.2-1.9-0.8c-0.3-0.4-0.4-1-0.4-2V11z M14,11.1c0-1.3-0.2-1.7-0.8-1.7 c-0.6,0-0.8,0.4-0.8,1.7v1.5c0,1.3,0.2,1.7,0.8,1.7c0.6,0,0.8-0.4,0.8-1.7V11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.2,9.9c0-0.7,0.1-1,0.4-1.3c0.3-0.3,0.7-0.4,1.4-0.4c0.7,0,1.1,0.2,1.4,0.5c0.2,0.3,0.3,0.6,0.3,1.2v0.7 c0,0.7-0.1,1-0.4,1.3c-0.3,0.3-0.7,0.4-1.4,0.4c-0.7,0-1.2-0.1-1.5-0.5c-0.2-0.3-0.3-0.6-0.3-1.2V9.9z M18.6,10 c0-0.7-0.2-0.9-0.5-0.9c-0.4,0-0.6,0.3-0.6,0.9v0.4c0,0.7,0.1,1,0.6,1c0.4,0,0.5-0.3,0.5-1V10z M21.2,8.3h1.3l-2.3,7.1h-1.3 L21.2,8.3z M21.7,13.2c0-0.7,0.1-1,0.4-1.3c0.3-0.3,0.7-0.4,1.4-0.4c0.7,0,1.1,0.2,1.4,0.5c0.2,0.3,0.3,0.6,0.3,1.2v0.7 c0,0.7-0.1,1-0.4,1.3c-0.3,0.3-0.7,0.4-1.4,0.4c-0.7,0-1.2-0.2-1.5-0.5c-0.2-0.3-0.3-0.6-0.3-1.2V13.2z M24,13.3 c0-0.7-0.1-0.9-0.5-0.9s-0.6,0.3-0.6,0.9v0.4c0,0.7,0.2,0.9,0.6,0.9s0.5-0.3,0.5-0.9V13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,8.3h1.5v5.9h3v1.2h-4.5V8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.5,11c0-1.1,0.2-1.6,0.6-2.1c0.5-0.5,1.1-0.7,2.1-0.7c1.1,0,1.7,0.2,2.2,0.8c0.3,0.5,0.5,1,0.5,2v1.7 c0,1.1-0.2,1.6-0.6,2.1c-0.5,0.5-1.1,0.7-2.1,0.7c-1.1,0-1.7-0.2-2.2-0.8c-0.3-0.4-0.5-1-0.5-2V11z M37.4,11.2 c0-1.3-0.3-1.7-1.2-1.7c-0.9,0-1.2,0.4-1.2,1.7v1.4c0,1.3,0.3,1.7,1.2,1.7c0.9,0,1.2-0.4,1.2-1.7V11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.3,9.5h-1.9V8.3h5.3v1.2h-1.9v5.9h-1.5V9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.7,13.5c0,0.6-0.2,1-0.5,1.4c-0.4,0.4-1.1,0.7-2.1,0.7c-1,0-1.7-0.3-2.1-0.9c-0.3-0.5-0.5-1-0.5-2v-1.6 c0-1.1,0.1-1.7,0.6-2.1c0.5-0.5,1.1-0.7,2-0.7c1.6,0,2.4,0.7,2.5,2.1l-1.4,0.1c-0.1-0.7-0.4-1-1-1c-0.8,0-1.1,0.4-1.1,1.8v1.3 c0,1.3,0.3,1.8,1.1,1.8c0.7,0,1-0.3,1.1-1L52.7,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,11c0-1.1,0.2-1.6,0.6-2.1c0.5-0.5,1.1-0.7,2.1-0.7c1.1,0,1.7,0.2,2.2,0.8c0.3,0.5,0.5,1,0.5,2v1.7 c0,1.1-0.2,1.6-0.6,2.1c-0.5,0.5-1.1,0.7-2.1,0.7c-1.1,0-1.7-0.2-2.2-0.8c-0.3-0.4-0.5-1-0.5-2V11z M57.5,11.2 c0-1.3-0.3-1.7-1.2-1.7c-0.9,0-1.2,0.4-1.2,1.7v1.4c0,1.3,0.3,1.7,1.2,1.7c0.9,0,1.2-0.4,1.2-1.7V11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.3,8.3h1.5l1.5,5.1l1.5-5.1h1.5L63,15.4h-1.3L59.3,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.2,8.3h4.5v1.2h-3v1.7h2.5v1.2h-2.5v1.7h3v1.2h-4.5V8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.6,15.4h-1.5V8.3h2.7c1,0,1.5,0.1,1.8,0.5c0.4,0.4,0.5,0.8,0.5,1.6c0,1.2-0.4,1.8-1.3,2.1l1.5,3h-1.7 l-1.3-2.8h-0.7V15.4z M74.6,11.4c0.7,0,1-0.3,1-0.9c0-0.7-0.3-1-1-1h-1v1.9H74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.5,14.1l-0.4,1.3h-1.7L80,8.3h1.5l2.6,7.1h-1.7L82,14.1H79.5z M80.8,10.1l-0.9,2.8h1.8L80.8,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,11.4h2.6v1.2c0,1-0.1,1.6-0.5,2c-0.5,0.6-1.1,0.8-2.2,0.8c-1.1,0-1.7-0.3-2.2-0.9c-0.3-0.5-0.5-1-0.5-2 v-1.5c0-1.1,0.2-1.7,0.6-2.2C85.4,8.4,86,8.2,87,8.2c1.7,0,2.5,0.7,2.5,2.1l-1.4,0.1c-0.1-0.7-0.4-1-1.1-1c-0.9,0-1.1,0.4-1.1,1.8 v1.3c0,1.3,0.3,1.8,1.2,1.8c0.8,0,1.2-0.4,1.2-1.3v-0.4h-1.1V11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.1,8.3h4.5v1.2h-3v1.7h2.5v1.2h-2.5v1.7h3v1.2h-4.5V8.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.8,24.9h-2v-0.4l1.6-3.7h0.6l-1.6,3.6h1.4v-1.5h0.5v1.5h0.5v0.5h-0.5v0.9h-0.5V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.4,24.8c0.2,0.4,0.6,0.5,1.2,0.5c0.7,0,1.1-0.3,1.1-0.9c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.2-0.1-0.9-0.3 c-1-0.3-1.4-0.7-1.4-1.4c0-0.9,0.6-1.4,1.5-1.4c0.7,0,1.2,0.2,1.4,0.6l-0.4,0.3c-0.2-0.3-0.6-0.4-1-0.4c-0.6,0-0.9,0.3-0.9,0.8 c0,0.5,0.3,0.8,1.1,1c0.7,0.2,0.8,0.2,1,0.4c0.3,0.2,0.5,0.6,0.5,1c0,0.9-0.6,1.4-1.7,1.4c-0.8,0-1.4-0.2-1.7-0.7L330.4,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,22.7v-0.5h0.4l0-1.1h0.5v1.1h0.7v0.5h-0.7v1.9c0,0.5,0.1,0.7,0.6,0.6h0.1v0.5h-0.1 c-0.9,0-1.1-0.2-1.1-1.2v-1.9H334z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.5,23.7c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6v0.5c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V23.7z  M338.8,23.8c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1v0.5c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.5,22.3h0.4l0.1,0.3c0.2-0.3,0.4-0.4,0.8-0.4c0.2,0,0.4,0,0.7,0.2l-0.2,0.5c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.7,0.4-0.7,1.4v1.7h-0.6V22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.7,22.3h0.6l1,2.9l0.9-2.9h0.6l-1.4,4.1c-0.3,0.9-0.5,1-1.4,1v-0.5c0.5,0,0.7-0.1,0.9-0.6l0.2-0.5 L342.7,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.1,20.8h1.8c0.5,0,0.8,0.1,1,0.3c0.2,0.2,0.4,0.6,0.4,1c0,0.5-0.2,0.9-0.6,1.1l0.1,0 c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.2,0.5,0.2,0.9c0,0.5-0.2,0.9-0.4,1.1c-0.2,0.2-0.5,0.3-1,0.3h-1.9V20.8z M349.9,23 c0.3,0,0.5,0,0.6-0.2c0.2-0.1,0.3-0.4,0.3-0.7c0-0.3-0.1-0.6-0.3-0.7c-0.2-0.1-0.3-0.2-0.6-0.2h-1.2V23H349.9z M350,25.3 c0.3,0,0.5-0.1,0.6-0.2c0.2-0.1,0.3-0.4,0.3-0.7c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.1-0.3-0.2-0.6-0.2h-1.3v1.8H350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.9,22.3v2c0,0.3,0,0.5,0.1,0.7c0.1,0.3,0.3,0.4,0.7,0.4c0.6,0,0.8-0.4,0.8-1.3v-1.8h0.6v3.5h-0.4l0-0.4 c-0.2,0.3-0.5,0.5-1,0.5c-0.6,0-1-0.2-1.1-0.7c-0.1-0.2-0.1-0.5-0.1-0.9v-2H352.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.3,20.8h0.6v0.7h-0.6V20.8z M356.3,22.3h0.6v3.5h-0.6V22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.6,20.8v3.9c0,0.5,0.1,0.7,0.6,0.7h0.2v0.5h-0.2c-0.9,0-1.1-0.2-1.1-1.2v-3.8H358.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.4,25.5C362.4,25.5,362.4,25.5,362.4,25.5c-0.1,0.1-0.1,0.1-0.1,0.1c-0.2,0.1-0.5,0.2-0.9,0.2 c-0.9,0-1.3-0.5-1.3-1.6v-0.5c0-1.1,0.4-1.6,1.3-1.6c0.3,0,0.6,0.1,0.8,0.2c0,0,0.1,0.1,0.2,0.2v-1.8h0.6v5h-0.4L362.4,25.5z  M360.6,24.3c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1v-0.6c0-0.7-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.1,20.8h0.6v0.7h-0.6V20.8z M364.1,22.3h0.6v3.5h-0.6V22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.9,22.3h0.4l0,0.4c0.2-0.3,0.5-0.5,1-0.5c0.6,0,1,0.2,1.2,0.7c0.1,0.2,0.1,0.5,0.1,0.9v2h-0.6v-2 c0-0.8-0.2-1.1-0.8-1.1c-0.6,0-0.8,0.4-0.8,1.3v1.8h-0.6V22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372,25.5c-0.2,0.2-0.5,0.3-1,0.3c-0.9,0-1.3-0.5-1.3-1.6v-0.5c0-1.1,0.4-1.6,1.3-1.6c0.5,0,0.8,0.1,1,0.4 l0-0.3h0.4v3.5c0,1.1-0.5,1.6-1.5,1.6c-0.6,0-1-0.2-1.2-0.6l0.4-0.3c0.2,0.3,0.4,0.4,0.8,0.4c0.7,0,0.9-0.3,1-1.1L372,25.5z  M370.3,24.3c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1v-0.6c0-0.7-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V24.3z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.1,28.5h2.9V29h-2.3v1.8h2v0.5h-2v2.2h-0.6V28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.4,28.5v3.9c0,0.5,0.1,0.7,0.6,0.7h0.2v0.5H330c-0.9,0-1.1-0.2-1.1-1.2v-3.8H329.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.8,31.4c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6V32c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V31.4z  M333.1,31.5c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V32c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.7,31.4c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6V32c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V31.4z  M337,31.5c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V32c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.7,30h0.4l0.1,0.3c0.2-0.3,0.4-0.4,0.8-0.4c0.2,0,0.4,0,0.7,0.2l-0.2,0.5c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.7,0.4-0.7,1.4v1.7h-0.6V30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.9,32.4l-0.4,1.1h-0.6l1.8-5h0.6l1.8,5h-0.6l-0.4-1.1H342.9z M344,29.2l-0.9,2.7h1.9L344,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.7,30h0.4l0.1,0.3c0.2-0.3,0.4-0.4,0.8-0.4c0.2,0,0.4,0,0.7,0.2l-0.2,0.5c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.7,0.4-0.7,1.4v1.7h-0.6V30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.7,32c0,0.7,0.3,1.1,1,1.1c0.4,0,0.6-0.1,0.8-0.3l0.4,0.3c-0.3,0.4-0.7,0.5-1.3,0.5c-1,0-1.5-0.5-1.5-1.7 v-0.3c0-1.2,0.4-1.7,1.4-1.7s1.4,0.5,1.4,1.7v0.3h-2.3V32z M351.5,31.4L351.5,31.4c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.4-0.3-0.7-0.3 c-0.4,0-0.6,0.1-0.7,0.4c-0.1,0.2-0.1,0.4-0.1,0.6v0.1H351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355,31.2c0-0.3,0-0.4-0.1-0.6c-0.1-0.2-0.4-0.3-0.6-0.3c-0.3,0-0.6,0.1-0.8,0.4l-0.4-0.3 c0.3-0.4,0.7-0.5,1.3-0.5c0.5,0,0.9,0.2,1.1,0.5c0.1,0.2,0.1,0.4,0.1,0.8v2.2h-0.4l0-0.3c-0.2,0.2-0.5,0.3-1,0.3 c-0.9,0-1.2-0.3-1.2-1c0-0.8,0.3-1.1,1.3-1.1h0.8V31.2z M354.2,31.8c-0.6,0-0.9,0.2-0.9,0.7c0,0.4,0.2,0.6,0.8,0.6 c0.4,0,0.6-0.1,0.7-0.2c0.1-0.1,0.1-0.2,0.1-0.5v-0.5H354.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.9,33.5h-0.6v-5h1.7c0.6,0,0.9,0.1,1.2,0.4c0.2,0.3,0.4,0.6,0.4,1c0,0.8-0.3,1.3-1,1.4l1.1,2.2H361l-1-2.2 h-1.1V33.5z M360,30.8c0.7,0,1-0.3,1-0.9c0-0.6-0.3-0.9-1-0.9h-1.1v1.9H360z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.6,31.2c0-0.3,0-0.4-0.1-0.6c-0.1-0.2-0.4-0.3-0.6-0.3c-0.3,0-0.6,0.1-0.8,0.4l-0.4-0.3 c0.3-0.4,0.7-0.5,1.3-0.5c0.5,0,0.9,0.2,1.1,0.5c0.1,0.2,0.1,0.4,0.1,0.8v2.2h-0.4l0-0.3c-0.2,0.2-0.5,0.3-1,0.3 c-0.9,0-1.2-0.3-1.2-1c0-0.8,0.3-1.1,1.3-1.1h0.8V31.2z M363.8,31.8c-0.6,0-0.9,0.2-0.9,0.7c0,0.4,0.2,0.6,0.8,0.6 c0.4,0,0.6-0.1,0.7-0.2c0.1-0.1,0.1-0.2,0.1-0.5v-0.5H363.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.1,30.4V30h0.4l0-1.1h0.5V30h0.7v0.5H367v1.9c0,0.5,0.1,0.7,0.6,0.6h0.1v0.5h-0.1c-0.9,0-1.1-0.2-1.1-1.2 v-1.9H366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.7,28.5h0.6v0.7h-0.6V28.5z M368.7,30h0.6v3.5h-0.6V30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.4,31.4c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6V32c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V31.4z  M372.7,31.5c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V32c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375.5,30.1h3.1v0.4h-3.1V30.1z M375.5,31.3h3.1v0.4h-3.1V31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.1,29.1l-0.9,0.4L381,29l1.2-0.5h0.4v5h-0.6V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384.8,32.8h0.6v0.7h-0.6V32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.6,30.2c0-0.7,0.1-1.1,0.3-1.3c0.3-0.3,0.6-0.5,1.1-0.5c0.5,0,0.9,0.2,1.1,0.6c0.2,0.3,0.3,0.7,0.3,1.3 v1.5c0,0.7-0.1,1.1-0.3,1.3c-0.3,0.3-0.6,0.5-1.1,0.5c-0.5,0-0.9-0.2-1.2-0.6c-0.2-0.3-0.3-0.7-0.3-1.3V30.2z M388.8,30.3 c0-1-0.2-1.4-0.8-1.4c-0.6,0-0.8,0.4-0.8,1.4v1.4c0,1,0.2,1.4,0.8,1.4c0.6,0,0.8-0.4,0.8-1.4V30.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.6,25.8L197,24c0.5-0.7,0.8-1.2,0.8-1.7c0-0.5-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.8,0.7l-0.5,0 c0.1-0.8,0.6-1.2,1.4-1.2c0.8,0,1.3,0.4,1.3,1.2c0,0.6-0.2,1-1,2l-1,1.3h2v0.5h-2.8V25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.1,25.2c0.2,0.4,0.6,0.5,1.2,0.5c0.7,0,1.1-0.3,1.1-0.9c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.2-0.1-0.9-0.3 c-1-0.3-1.4-0.7-1.4-1.4c0-0.9,0.6-1.4,1.5-1.4c0.7,0,1.2,0.2,1.4,0.6l-0.4,0.3c-0.2-0.3-0.6-0.4-1-0.4c-0.6,0-0.9,0.3-0.9,0.8 c0,0.5,0.3,0.8,1.1,1c0.7,0.2,0.8,0.2,1,0.4c0.3,0.2,0.5,0.6,0.5,1c0,0.9-0.6,1.4-1.7,1.4c-0.8,0-1.4-0.2-1.7-0.7L201.1,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.7,23.1v-0.5h0.4l0-1.1h0.5v1.1h0.7v0.5h-0.7v1.9c0,0.5,0.1,0.7,0.6,0.6h0.1v0.5h-0.1 c-0.9,0-1.1-0.2-1.1-1.2v-1.9H204.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.3,24.2c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6v0.5c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V24.2z  M209.6,24.2c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1v0.5c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.3,22.7h0.4l0.1,0.3c0.2-0.3,0.4-0.4,0.8-0.4c0.2,0,0.4,0,0.7,0.2l-0.2,0.5c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.7,0.4-0.7,1.4v1.7h-0.6V22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.4,22.7h0.6l1,2.9l0.9-2.9h0.6l-1.4,4.1c-0.3,0.9-0.5,1-1.4,1v-0.5c0.5,0,0.7-0.1,0.9-0.6l0.2-0.5 L213.4,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.8,21.2h1.8c0.5,0,0.8,0.1,1,0.3c0.2,0.2,0.4,0.6,0.4,1c0,0.5-0.2,0.9-0.6,1.1l0.1,0 c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.2,0.5,0.2,0.9c0,0.5-0.2,0.9-0.4,1.1c-0.2,0.2-0.5,0.3-1,0.3h-1.9V21.2z M220.6,23.4 c0.3,0,0.5,0,0.6-0.2c0.2-0.1,0.3-0.4,0.3-0.7c0-0.3-0.1-0.6-0.3-0.7c-0.2-0.1-0.3-0.2-0.6-0.2h-1.2v1.7H220.6z M220.7,25.7 c0.3,0,0.5-0.1,0.6-0.2c0.2-0.1,0.3-0.4,0.3-0.7c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.1-0.3-0.2-0.6-0.2h-1.3v1.8H220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.7,22.7v2c0,0.3,0,0.5,0.1,0.7c0.1,0.3,0.3,0.4,0.7,0.4c0.6,0,0.8-0.4,0.8-1.3v-1.8h0.6v3.5h-0.4l0-0.4 c-0.2,0.3-0.5,0.5-1,0.5c-0.6,0-1-0.2-1.1-0.7c-0.1-0.2-0.1-0.5-0.1-0.9v-2H223.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.1,21.2h0.6v0.7h-0.6V21.2z M227.1,22.7h0.6v3.5h-0.6V22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.4,21.2v3.9c0,0.5,0.1,0.7,0.6,0.7h0.2v0.5H230c-0.9,0-1.1-0.2-1.1-1.2v-3.8H229.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.2,25.9C233.1,25.9,233.1,25.9,233.2,25.9c-0.1,0.1-0.1,0.1-0.1,0.1c-0.2,0.1-0.5,0.2-0.9,0.2 c-0.9,0-1.3-0.5-1.3-1.6v-0.5c0-1.1,0.4-1.6,1.3-1.6c0.3,0,0.6,0.1,0.8,0.2c0,0,0.1,0.1,0.2,0.2v-1.8h0.6v5h-0.4L233.2,25.9z  M231.3,24.7c0,0.8,0.3,1.1,0.9,1.1s0.9-0.4,0.9-1.1v-0.6c0-0.7-0.3-1.1-0.9-1.1s-0.9,0.4-0.9,1.1V24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.9,21.2h0.6v0.7h-0.6V21.2z M234.9,22.7h0.6v3.5h-0.6V22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.6,22.7h0.4l0,0.4c0.2-0.3,0.5-0.5,1-0.5c0.6,0,1,0.2,1.2,0.7c0.1,0.2,0.1,0.5,0.1,0.9v2h-0.6v-2 c0-0.8-0.2-1.1-0.8-1.1c-0.6,0-0.8,0.4-0.8,1.3v1.8h-0.6V22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.8,25.9c-0.2,0.2-0.5,0.3-1,0.3c-0.9,0-1.3-0.5-1.3-1.6v-0.5c0-1.1,0.4-1.6,1.3-1.6c0.5,0,0.8,0.1,1,0.4 l0-0.3h0.4v3.5c0,1.1-0.5,1.6-1.5,1.6c-0.6,0-1-0.2-1.2-0.6L241,27c0.2,0.3,0.4,0.4,0.8,0.4c0.7,0,0.9-0.3,1-1.1L242.8,25.9z  M241,24.7c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1v-0.6c0-0.7-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V24.7z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.9,28.9h2.9v0.5h-2.3v1.8h2v0.5h-2v2.2h-0.6V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.2,28.9v3.9c0,0.5,0.1,0.7,0.6,0.7h0.2v0.5h-0.2c-0.9,0-1.1-0.2-1.1-1.2v-3.8H200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.6,31.9c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6v0.5c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V31.9z  M203.9,31.9c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1v0.5c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.5,31.9c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6v0.5c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V31.9z  M207.8,31.9c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1v0.5c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.5,30.4h0.4l0.1,0.3c0.2-0.3,0.4-0.4,0.8-0.4c0.2,0,0.4,0,0.7,0.2l-0.2,0.5c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.7,0.4-0.7,1.4v1.7h-0.6V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.6,32.8l-0.4,1.1h-0.6l1.8-5h0.6l1.8,5h-0.6l-0.4-1.1H213.6z M214.7,29.6l-0.9,2.7h1.9L214.7,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.4,30.4h0.4l0.1,0.3c0.2-0.3,0.4-0.4,0.8-0.4c0.2,0,0.4,0,0.7,0.2l-0.2,0.5c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.7,0.4-0.7,1.4v1.7h-0.6V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.5,32.4c0,0.7,0.3,1.1,1,1.1c0.4,0,0.6-0.1,0.8-0.3l0.4,0.3c-0.3,0.4-0.7,0.5-1.3,0.5 c-1,0-1.5-0.5-1.5-1.7V32c0-1.2,0.4-1.7,1.4-1.7c1,0,1.4,0.5,1.4,1.7v0.3h-2.3V32.4z M222.3,31.8L222.3,31.8c0-0.3-0.1-0.6-0.2-0.8 c-0.1-0.2-0.4-0.3-0.7-0.3c-0.4,0-0.6,0.1-0.7,0.4c-0.1,0.2-0.1,0.4-0.1,0.6v0.1H222.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.8,31.6c0-0.3,0-0.4-0.1-0.6c-0.1-0.2-0.3-0.3-0.6-0.3c-0.3,0-0.6,0.1-0.8,0.4l-0.4-0.3 c0.3-0.4,0.7-0.5,1.3-0.5c0.5,0,0.9,0.2,1.1,0.5c0.1,0.2,0.1,0.4,0.1,0.8v2.2h-0.4l0-0.3c-0.2,0.2-0.5,0.3-1,0.3 c-0.9,0-1.2-0.3-1.2-1c0-0.8,0.3-1.1,1.3-1.1h0.8V31.6z M225,32.2c-0.6,0-0.9,0.2-0.9,0.7c0,0.4,0.2,0.6,0.8,0.6 c0.4,0,0.6-0.1,0.7-0.2c0.1-0.1,0.1-0.2,0.1-0.5v-0.5H225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.6,33.9h-0.6v-5h1.7c0.6,0,0.9,0.1,1.2,0.4c0.2,0.3,0.4,0.6,0.4,1c0,0.8-0.3,1.3-1,1.4l1.1,2.2h-0.6 l-1-2.2h-1.1V33.9z M230.8,31.2c0.7,0,1-0.3,1-0.9c0-0.6-0.3-0.9-1-0.9h-1.1v1.9H230.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.4,31.6c0-0.3,0-0.4-0.1-0.6c-0.1-0.2-0.3-0.3-0.6-0.3c-0.3,0-0.6,0.1-0.8,0.4l-0.4-0.3 c0.3-0.4,0.7-0.5,1.3-0.5c0.5,0,0.9,0.2,1.1,0.5c0.1,0.2,0.1,0.4,0.1,0.8v2.2h-0.4l0-0.3c-0.2,0.2-0.5,0.3-1,0.3 c-0.9,0-1.2-0.3-1.2-1c0-0.8,0.3-1.1,1.3-1.1h0.8V31.6z M234.6,32.2c-0.6,0-0.9,0.2-0.9,0.7c0,0.4,0.2,0.6,0.8,0.6 c0.4,0,0.6-0.1,0.7-0.2c0.1-0.1,0.1-0.2,0.1-0.5v-0.5H234.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.8,30.8v-0.5h0.4l0-1.1h0.5v1.1h0.7v0.5h-0.7v1.9c0,0.5,0.1,0.7,0.6,0.6h0.1v0.5h-0.1 c-0.9,0-1.1-0.2-1.1-1.2v-1.9H236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.5,28.9h0.6v0.7h-0.6V28.9z M239.5,30.4h0.6v3.5h-0.6V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.1,31.9c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6v0.5c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V31.9z  M243.5,31.9c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1v0.5c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.3,30.6h3.1V31h-3.1V30.6z M246.3,31.7h3.1v0.4h-3.1V31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8,29.5l-0.9,0.4l-0.2-0.5l1.2-0.5h0.4v5h-0.6V29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.6,33.2h0.6v0.7h-0.6V33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.4,30.6c0-0.7,0.1-1.1,0.3-1.3c0.3-0.3,0.6-0.5,1.1-0.5c0.5,0,0.9,0.2,1.1,0.6c0.2,0.3,0.3,0.7,0.3,1.3 v1.5c0,0.7-0.1,1.1-0.3,1.3c-0.3,0.3-0.6,0.5-1.1,0.5c-0.5,0-0.9-0.2-1.2-0.6c-0.2-0.3-0.3-0.7-0.3-1.3V30.6z M259.6,30.7 c0-1-0.2-1.4-0.8-1.4c-0.6,0-0.8,0.4-0.8,1.4v1.4c0,1,0.2,1.4,0.8,1.4c0.6,0,0.8-0.4,0.8-1.4V30.7z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,21.4l-0.9,0.4L1,21.3l1.2-0.5h0.4v5H2V21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,24.8c0.2,0.4,0.6,0.5,1.2,0.5c0.7,0,1.1-0.3,1.1-0.9c0-0.3-0.1-0.5-0.3-0.6c-0.2-0.1-0.2-0.1-0.9-0.3 c-1-0.3-1.4-0.7-1.4-1.4c0-0.9,0.6-1.4,1.5-1.4c0.7,0,1.2,0.2,1.4,0.6l-0.4,0.3c-0.2-0.3-0.6-0.4-1-0.4c-0.6,0-0.9,0.3-0.9,0.8 c0,0.5,0.3,0.8,1.1,1c0.7,0.2,0.8,0.2,1,0.4c0.3,0.2,0.5,0.6,0.5,1c0,0.9-0.6,1.4-1.7,1.4c-0.8,0-1.4-0.2-1.7-0.7L6.3,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,22.7v-0.5h0.4l0-1.1h0.5v1.1h0.7v0.5h-0.7v1.9c0,0.5,0.1,0.7,0.6,0.6h0.1v0.5h-0.1 c-0.9,0-1.1-0.2-1.1-1.2v-1.9H9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,23.8c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6v0.5c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V23.8z  M14.8,23.8c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1v0.5c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4,22.3h0.4l0.1,0.3c0.2-0.3,0.4-0.4,0.8-0.4c0.2,0,0.4,0,0.7,0.2l-0.2,0.5c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.7,0.4-0.7,1.4v1.7h-0.6V22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,22.3h0.6l1,2.9l0.9-2.9h0.6l-1.4,4.1c-0.3,0.9-0.5,1-1.4,1v-0.5c0.5,0,0.7-0.1,0.9-0.6l0.2-0.5 L18.6,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,20.8h1.8c0.5,0,0.8,0.1,1,0.3c0.2,0.2,0.4,0.6,0.4,1c0,0.5-0.2,0.9-0.6,1.1l0.1,0c0.2,0.1,0.3,0.2,0.4,0.4 c0.1,0.2,0.2,0.5,0.2,0.9c0,0.5-0.2,0.9-0.4,1.1c-0.2,0.2-0.5,0.3-1,0.3H24V20.8z M25.8,23c0.3,0,0.5,0,0.6-0.2 c0.2-0.1,0.3-0.4,0.3-0.7c0-0.3-0.1-0.6-0.3-0.7c-0.2-0.1-0.3-0.2-0.6-0.2h-1.2V23H25.8z M25.9,25.3c0.3,0,0.5-0.1,0.6-0.2 c0.2-0.1,0.3-0.4,0.3-0.7c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.1-0.3-0.2-0.6-0.2h-1.3v1.8H25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,22.3v2c0,0.3,0,0.5,0.1,0.7c0.1,0.3,0.3,0.4,0.7,0.4c0.6,0,0.8-0.4,0.8-1.3v-1.8H31v3.5h-0.4l0-0.4 c-0.2,0.3-0.5,0.5-1,0.5c-0.6,0-1-0.2-1.1-0.7c-0.1-0.2-0.1-0.5-0.1-0.9v-2H28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.2,20.8h0.6v0.7h-0.6V20.8z M32.2,22.3h0.6v3.5h-0.6V22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,20.8v3.9c0,0.5,0.1,0.7,0.6,0.7h0.2v0.5h-0.2c-0.9,0-1.1-0.2-1.1-1.2v-3.8H34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.3,25.5C38.3,25.5,38.3,25.5,38.3,25.5c-0.1,0.1-0.1,0.1-0.1,0.1c-0.2,0.1-0.5,0.2-0.9,0.2 c-0.9,0-1.3-0.5-1.3-1.6v-0.5c0-1.1,0.4-1.6,1.3-1.6c0.3,0,0.6,0.1,0.8,0.2c0,0,0.1,0.1,0.2,0.2v-1.8h0.6v5h-0.4L38.3,25.5z  M36.5,24.3c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1v-0.6c0-0.7-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,20.8h0.6v0.7H40V20.8z M40,22.3h0.6v3.5H40V22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,22.3h0.4l0,0.4c0.2-0.3,0.5-0.5,1-0.5c0.6,0,1,0.2,1.2,0.7c0.1,0.2,0.1,0.5,0.1,0.9v2H44v-2 c0-0.8-0.2-1.1-0.8-1.1c-0.6,0-0.8,0.4-0.8,1.3v1.8h-0.6V22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.9,25.5c-0.2,0.2-0.5,0.3-1,0.3c-0.9,0-1.3-0.5-1.3-1.6v-0.5c0-1.1,0.4-1.6,1.3-1.6c0.5,0,0.8,0.1,1,0.4 l0-0.3h0.4v3.5c0,1.1-0.5,1.6-1.5,1.6c-0.6,0-1-0.2-1.2-0.6l0.4-0.3c0.2,0.3,0.4,0.4,0.8,0.4c0.7,0,0.9-0.3,1-1.1L47.9,25.5z  M46.2,24.3c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1v-0.6c0-0.7-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V24.3z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.1,28.5H4V29H1.6v1.8h2v0.5h-2v2.2H1.1V28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,28.5v3.9c0,0.5,0.1,0.7,0.6,0.7h0.2v0.5H5.9c-0.9,0-1.1-0.2-1.1-1.2v-3.8H5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,31.5c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6V32c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V31.5z  M9,31.5c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V32c0,0.8,0.3,1.1,0.9,1.1C8.8,33.1,9,32.7,9,32V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,31.5c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6V32c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V31.5z  M12.9,31.5c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V32c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,30H15l0.1,0.3c0.2-0.3,0.4-0.4,0.8-0.4c0.2,0,0.4,0,0.7,0.2l-0.2,0.5c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.7,0.4-0.7,1.4v1.7h-0.6V30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,32.4l-0.4,1.1h-0.6l1.8-5h0.6l1.8,5h-0.6L21,32.4H18.8z M19.9,29.2l-0.9,2.7h1.9L19.9,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.6,30H23l0.1,0.3c0.2-0.3,0.4-0.4,0.8-0.4c0.2,0,0.4,0,0.7,0.2l-0.2,0.5c-0.2-0.1-0.3-0.2-0.5-0.2 c-0.5,0-0.7,0.4-0.7,1.4v1.7h-0.6V30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6,32c0,0.7,0.3,1.1,1,1.1c0.4,0,0.6-0.1,0.8-0.3l0.4,0.3c-0.3,0.4-0.7,0.5-1.3,0.5c-1,0-1.5-0.5-1.5-1.7 v-0.3c0-1.2,0.4-1.7,1.4-1.7c1,0,1.4,0.5,1.4,1.7v0.3h-2.3V32z M27.4,31.4L27.4,31.4c0-0.3-0.1-0.6-0.2-0.8 c-0.1-0.2-0.4-0.3-0.7-0.3c-0.4,0-0.6,0.1-0.7,0.4c-0.1,0.2-0.1,0.4-0.1,0.6v0.1H27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.9,31.2c0-0.3,0-0.4-0.1-0.6c-0.1-0.2-0.4-0.3-0.6-0.3c-0.3,0-0.6,0.1-0.8,0.4l-0.4-0.3 c0.3-0.4,0.7-0.5,1.3-0.5c0.5,0,0.9,0.2,1.1,0.5c0.1,0.2,0.1,0.4,0.1,0.8v2.2H31l0-0.3c-0.2,0.2-0.5,0.3-1,0.3 c-0.9,0-1.2-0.3-1.2-1c0-0.8,0.3-1.1,1.3-1.1h0.8V31.2z M30.1,31.8c-0.6,0-0.9,0.2-0.9,0.7c0,0.4,0.2,0.6,0.8,0.6 c0.4,0,0.6-0.1,0.7-0.2c0.1-0.1,0.1-0.2,0.1-0.5v-0.5H30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.8,33.5h-0.6v-5h1.7c0.6,0,0.9,0.1,1.2,0.4c0.2,0.3,0.4,0.6,0.4,1c0,0.8-0.3,1.3-1,1.4l1.1,2.2h-0.6l-1-2.2 h-1.1V33.5z M35.9,30.9c0.7,0,1-0.3,1-0.9c0-0.6-0.3-0.9-1-0.9h-1.1v1.9H35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,31.2c0-0.3,0-0.4-0.1-0.6c-0.1-0.2-0.4-0.3-0.6-0.3c-0.3,0-0.6,0.1-0.8,0.4l-0.4-0.3 c0.3-0.4,0.7-0.5,1.3-0.5c0.5,0,0.9,0.2,1.1,0.5c0.1,0.2,0.1,0.4,0.1,0.8v2.2h-0.4l0-0.3c-0.2,0.2-0.5,0.3-1,0.3 c-0.9,0-1.2-0.3-1.2-1c0-0.8,0.3-1.1,1.3-1.1h0.8V31.2z M39.7,31.8c-0.6,0-0.9,0.2-0.9,0.7c0,0.4,0.2,0.6,0.8,0.6 c0.4,0,0.6-0.1,0.7-0.2c0.1-0.1,0.1-0.2,0.1-0.5v-0.5H39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,30.4V30h0.4l0-1.1h0.5V30h0.7v0.5h-0.7v1.9c0,0.5,0.1,0.7,0.6,0.6h0.1v0.5h-0.1c-0.9,0-1.1-0.2-1.1-1.2 v-1.9H42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.6,28.5h0.6v0.7h-0.6V28.5z M44.6,30h0.6v3.5h-0.6V30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.3,31.5c0-1.1,0.5-1.6,1.4-1.6c1,0,1.5,0.5,1.5,1.6V32c0,1.1-0.5,1.5-1.5,1.5c-1,0-1.4-0.5-1.4-1.5V31.5z  M48.6,31.5c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.4-0.9,1.1V32c0,0.8,0.3,1.1,0.9,1.1c0.6,0,0.9-0.4,0.9-1.1V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.4,30.2h3.1v0.4h-3.1V30.2z M51.4,31.3h3.1v0.4h-3.1V31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58,29.1l-0.9,0.4L56.9,29l1.2-0.5h0.4v5H58V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.7,32.8h0.6v0.7h-0.6V32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.5,30.3c0-0.7,0.1-1.1,0.3-1.3c0.3-0.3,0.6-0.5,1.1-0.5c0.5,0,0.9,0.2,1.1,0.6c0.2,0.3,0.3,0.7,0.3,1.3v1.5 c0,0.7-0.1,1.1-0.3,1.3c-0.3,0.3-0.6,0.5-1.1,0.5c-0.5,0-0.9-0.2-1.2-0.6c-0.2-0.3-0.3-0.7-0.3-1.3V30.3z M64.7,30.3 c0-1-0.2-1.4-0.8-1.4c-0.6,0-0.8,0.4-0.8,1.4v1.4c0,1,0.2,1.4,0.8,1.4c0.6,0,0.8-0.4,0.8-1.4V30.3z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 39.5,
    className: "st1",
    width: 97.1,
    height: 10.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 39.5,
    className: "st0",
    width: 50.9,
    height: 10.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 27.3,
    className: "st0",
    width: 50.9,
    height: 10.3
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.2,40.2h4.6v-0.7h-4.6V40.2z M153.6,40.2h4.6v-0.7h-4.6V40.2z M161,40.2h4.6v-0.7H161V40.2z M168.4,40.2 h4.6v-0.7h-4.6V40.2z M175.8,40.2h4.6v-0.7h-4.6V40.2z M183.2,40.2h4.6v-0.7h-4.6V40.2z M190.6,40.2h4.6v-0.7h-4.6V40.2z  M198.1,40.2h4.6v-0.7h-4.6V40.2z M205.5,40.2h4.6v-0.7h-4.6V40.2z M212.9,40.2h4.6v-0.7h-4.6V40.2z M220.3,40.2h4.6v-0.7h-4.6 V40.2z M227.7,40.2h4.6v-0.7h-4.6V40.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "143.4,39.5 140.8,39.5 140.8,42.1 141.5,42.1 141.5,40.2 143.4,40.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.8,
    y: 43.5,
    className: "st0",
    width: 0.7,
    height: 2.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "140.8,47.3 140.8,49.9 143.4,49.9 143.4,49.2 141.5,49.2 141.5,47.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.2,49.9h4.6v-0.7h-4.6V49.9z M153.6,49.9h4.6v-0.7h-4.6V49.9z M161,49.9h4.6v-0.7H161V49.9z M168.4,49.9 h4.6v-0.7h-4.6V49.9z M175.8,49.9h4.6v-0.7h-4.6V49.9z M183.2,49.9h4.6v-0.7h-4.6V49.9z M190.6,49.9h4.6v-0.7h-4.6V49.9z  M198.1,49.9h4.6v-0.7h-4.6V49.9z M205.5,49.9h4.6v-0.7h-4.6V49.9z M212.9,49.9h4.6v-0.7h-4.6V49.9z M220.3,49.9h4.6v-0.7h-4.6 V49.9z M227.7,49.9h4.6v-0.7h-4.6V49.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "235.1,49.9 237.7,49.9 237.7,47.3 237,47.3 237,49.2 235.1,49.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 43.5,
    className: "st0",
    width: 0.7,
    height: 2.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "237.7,42.1 237.7,39.5 235.1,39.5 235.1,40.2 237,40.2 237,42.1  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarGraphic);
export default __webpack_public_path__ + "static/media/FAR_graphic.bec3fb14e0e400e7ee03ac646793e72f.svg";
export { ForwardRef as ReactComponent };